import Report from './report'
import Card from './card'
import Edit from './edit'
import New from './new'

const card = {
  code: 'affiliate_monthly_recurring_revenue',
  card: Card,
  edit: Edit,
  new: New,
  report: Report
}

export default card
